import React, { useState, useEffect } from 'react';
import { Container } from '@material-ui/core';
import {
    SelectDmtPipe as SELECT_DMT_PIPE,
    ActiveDeactive as DMT_PIPE_ACTIVATE
} from 'Components/Api/DMTPipeMasterAPI';

import { LOGOUT } from 'ConstComponents';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { Formik, Form } from 'formik';

const CustomContainer = HOCLoader(Container);

export const DMTPipeMaster = ({ }) => {
    const classes = commonStyle();

    const [itemList, setItemList] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');

    const FormObj = {
        IsActive: '',
        Status: 0
    };

    useEffect(() => {
        select();
        createColumns();
    }, []);

    const select = async () => {
        var inputObj = {
            Status: 'PROCESS'
        };
        setLoadingOpen(true);
        setItemList([]);
        var requestObj = JSON.stringify(inputObj);

        const response = await SELECT_DMT_PIPE(requestObj);
        setLoadingOpen(false);

        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);

            setIsError(true);
            return;
        }
        var data = JSON.parse(response.data);
        setItemList(data);
    };

    const submithandle = async (item, value) => {
        let jsonObj = {
            DMTPipeMasterID: item,
            IsActive: value
        };
        let request = JSON.stringify(jsonObj);

        setLoadingOpen(true);
        setIsError(false);
        const response = await DMT_PIPE_ACTIVATE(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);
        if (!response.status) setSeverity('error');
        setIsError(true);
        select();
    };

    const createColumns = () => {
        let primaryKeyIndex = 0;
        var columns = [];

        columns.push({
            label: '#',
            name: 'DMTPipeMasterID',
            srno: true
        });
        columns.push({
            label: 'ActiveDMTName',
            name: 'ActiveDMTName'
        });

        columns.push({
            label: 'BankName',
            name: 'BankName'
        });
        columns.push({
            label: 'Value',
            name: 'Value'
        });

        columns.push({
            label: 'Active',
            name: 'IsActive',
            activate: true,
            primaryKeyIndex: primaryKeyIndex,
            callback: (id, value) => {
                submithandle(id, value);
            }
        });

        setMainColumns(columns);
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                onSubmit={submithandle}
                resetForm={FormObj}
            >
                {({ }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>DMT Pipe Master</h2>
                        </Form>
                    );
                }}
            </Formik>
            <ReactTable
                data={itemList}
                rowsPerPage={100}
                columns={mainColumns}
            />
        </CustomContainer>
    );
};
